import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';

const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already accepted cookies
    const cookieConsent = localStorage.getItem('cookie-consent');
    if (!cookieConsent) {
      setShowBanner(true);
    }
  }, []);

  const acceptAll = () => {
    localStorage.setItem('cookie-consent', 'all');
    localStorage.setItem('cookie-consent-date', new Date().toISOString());
    setShowBanner(false);
    // Enable Google Analytics
    if (window.gtag) {
      window.gtag('consent', 'update', {
        'analytics_storage': 'granted',
        'ad_storage': 'granted'
      });
    }
  };

  const acceptEssential = () => {
    localStorage.setItem('cookie-consent', 'essential');
    localStorage.setItem('cookie-consent-date', new Date().toISOString());
    setShowBanner(false);
    // Disable Google Analytics
    if (window.gtag) {
      window.gtag('consent', 'update', {
        'analytics_storage': 'denied',
        'ad_storage': 'denied'
      });
    }
  };

  if (!showBanner) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-end sm:items-center justify-center p-4 bg-black/50" data-testid="cookie-banner">
      <div className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full p-6 md:p-8 max-h-[90vh] overflow-y-auto">
        <div className="flex justify-between items-start mb-4">
          <h2 className="font-['Merriweather'] text-xl md:text-2xl font-bold text-slate-900">
            Cookie-Einstellungen
          </h2>
        </div>
        
        <div className="text-slate-600 mb-6 space-y-4">
          <p>
            Wir verwenden Cookies und ähnliche Technologien, um Ihnen die bestmögliche 
            Nutzererfahrung zu bieten. Einige Cookies sind für den Betrieb der Website 
            erforderlich, während andere uns helfen, die Website zu verbessern und 
            Ihnen personalisierte Inhalte anzuzeigen.
          </p>
          
          <div className="bg-slate-50 rounded-lg p-4">
            <h3 className="font-semibold text-slate-900 mb-2">Notwendige Cookies</h3>
            <p className="text-sm">
              Diese Cookies sind für die Grundfunktionen der Website erforderlich 
              (z.B. Terminbuchung, Sitzungsverwaltung).
            </p>
          </div>
          
          <div className="bg-slate-50 rounded-lg p-4">
            <h3 className="font-semibold text-slate-900 mb-2">Marketing & Analyse</h3>
            <p className="text-sm">
              Google Analytics und Google Ads helfen uns zu verstehen, wie Besucher 
              unsere Website nutzen und ermöglichen personalisierte Werbung.
            </p>
          </div>

          <p className="text-sm">
            Weitere Informationen finden Sie in unserer{' '}
            <a 
              href="/datenschutz" 
              className="text-[#40E0D0] hover:underline font-medium"
            >
              Datenschutzerklärung
            </a>.
          </p>
        </div>
        
        <div className="flex flex-col sm:flex-row gap-3">
          <Button
            onClick={acceptEssential}
            variant="outline"
            className="flex-1 py-3 rounded-full border-2 border-slate-200 hover:border-slate-300 font-semibold"
            data-testid="cookie-essential"
          >
            Nur Notwendige
          </Button>
          <Button
            onClick={acceptAll}
            className="flex-1 py-3 rounded-full bg-[#40E0D0] text-slate-900 hover:bg-[#3BCCC0] font-bold"
            data-testid="cookie-accept-all"
          >
            Alle akzeptieren
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
